import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';



class Classes extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='Classes'>
      <div><Link to='/'>Home</Link></div>
      <h3>BMZ Dojo's classes</h3>

      <br />
      <br />

        <div><Link to='/rosterbmz'>Saturday 16.30-18.00</Link></div>
        <br />
        <div><Link to='/rosterbmz'>Sunday 15.30-17.30(Goshin Jitsu)</Link></div>

        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Classes;
